module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "is-loading": "is-loading"
    }
  }) : (_vm.isOnBackupCodesScreen) ? [_c('p', {
    staticClass: "section"
  }, [_vm._v("Setup complete!")]), _c('p', {
    staticClass: "section"
  }, [_vm._v("Please write down these backup codes. They allow you to restore access to your account if you \nlose access to your two-factor authentication codes. You \ncan then enter one of these instead. Note that eaach of these \ncodes can only be used once.")]), _c('pre', {
    staticClass: "section backup-codes"
  }, [_vm._v(_vm._s(_vm.backupCodesFormatted))]), _c('button', {
    staticClass: "w-button w-button--blue",
    on: {
      "click": function($event) {
        return _vm.$emit('setup-complete')
      }
    }
  }, [_vm._v("Ok")])] : [(_vm.forced) ? _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("An administrator has enforced two factor authentication on this site. ")])]) : _vm._e(), _c('p', {
    staticClass: "section"
  }, [_vm._v("Two-factor authentication setup is required to proceed. Please download "), _c('b', [_vm._v("Google Authenticator")]), _vm._v(" app for "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
    }
  }, [_vm._v("Android ")]), _vm._v("or "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/google-authenticator/id388497605"
    }
  }, [_vm._v("iPhone")]), _vm._v(".")]), (_vm.seed) ? _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("Enter the provided key into the app: "), _c('b', {
    domProps: {
      "textContent": _vm._s(_vm.seed)
    }
  })])]) : _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("Scan the barcode with the app:")]), _c('img', {
    staticClass: "qr",
    attrs: {
      "src": "/launchpad/2fa/login/setup/qr"
    }
  }), _c('p', [_vm._v("If you're unable to scan the barcode, you can "), _c('a', {
    staticClass: "seed-button",
    on: {
      "click": _vm.getSeed
    }
  }, [_vm._v("enter the key manually")]), _vm._v(".")])]), _c('p', {
    staticClass: "section"
  }, [_vm._v("After that, enter the 6-digit code that is shown in the app below:")]), _c('div', {
    staticClass: "w-input code-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "tfa-code"
    }
  }, [_vm._v("Authentication code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeModel),
      expression: "codeModel"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "tfa-code",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.codeModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeModel = $event.target.value
      }
    }
  })]), (_vm.errorMessage) ? _c('p', {
    staticClass: "error is-invalid"
  }, [_vm._v("Error: " + _vm._s(_vm.errorMessage))]) : _vm._e(), _c('button', {
    staticClass: "w-button w-button--blue",
    on: {
      "click": _vm.setupTfa
    }
  }, [_vm._v("Verify")]), _c('button', {
    staticClass: "w-button w-button--link",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81519574","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Login/TfaSetup.vue
// module id = 608
// module chunks = 1